/* unplugin-vue-components disabled */import { render } from "./DeviceAndroid.vue?vue&type=template&id=1c33f6a2&scoped=true"
import script from "./DeviceAndroid.vue?vue&type=script&lang=js"
export * from "./DeviceAndroid.vue?vue&type=script&lang=js"

import "./DeviceAndroid.vue?vue&type=style&index=0&id=1c33f6a2&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c33f6a2"]])

export default __exports__